import { render } from "./App.vue?vue&type=template&id=bc5306ce&translate=no"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "E:\\GitHub\\Tribal\\Agro\\agcam_frontend_productores\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__